import { render } from "./certificateInquiry.vue?vue&type=template&id=31d3708f&scoped=true"
import script from "./certificateInquiry.vue?vue&type=script&lang=js"
export * from "./certificateInquiry.vue?vue&type=script&lang=js"

import "./certificateInquiry.vue?vue&type=style&index=0&id=31d3708f&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d3708f"]])

export default __exports__